module.exports = __webpack_public_path__ + "static/author-yasir-al-kazwini-984e7486bf1424d3ff73c7ac13ecf458.png";